import { Bell, Moon, Sun } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '@/shared/stores/uiStore';
import { useTheme } from '@/app/providers/ThemeProvider';
import { UserMenu } from '@/features/auth/components/UserMenu';
import { useUnreadNotificationCount } from '@/features/notifications/hooks/useNotifications';

export function Header() {
  const { sidebarOpen, toggleSidebar } = useUIStore();
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();
  const { data: unreadCount = 0 } = useUnreadNotificationCount();

  return (
    <header className="glass-nav sticky top-0 z-20 flex h-14 items-center gap-4 border-b px-4 sm:px-6">
      <button
        onClick={toggleSidebar}
        className="rounded-md p-1 text-muted-foreground hover:bg-accent"
        aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
      >
        <svg
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={sidebarOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
          />
        </svg>
      </button>

      <div className="flex-1" />

      <div className="flex items-center gap-1 sm:gap-2">
        <button
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          className="rounded-md p-2 text-muted-foreground hover:bg-accent"
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
        <button
          onClick={() => navigate('/notifications')}
          className="relative rounded-md p-2 text-muted-foreground hover:bg-accent"
          aria-label="Notifications"
        >
          <Bell className="h-4 w-4" />
          {unreadCount > 0 && (
            <span className="absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-destructive text-[10px] text-destructive-foreground">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
        <UserMenu />
      </div>
    </header>
  );
}
